import { GoogleAiVoiceDraftV1, GoogleSynthesisRequest } from '../types';

export const GOOGLE_TTS_INPUT_BYTE_LIMIT = 4000;
const GOOGLE_TTS_TEXT_LENGTH_ERROR_MESSAGE = 'The text is too long.';
const GOOGLE_TTS_PROMPT_LENGTH_ERROR_MESSAGE = 'The prompt is too long.';

const utf8Encoder = new TextEncoder();

const getUtf8ByteLength = (value: string) => utf8Encoder.encode(value).length;

export const buildGoogleSynthesisRequest = (
  draft: GoogleAiVoiceDraftV1,
  requestedAudioEncoding: NonNullable<GoogleSynthesisRequest['audioConfig']>['audioEncoding'] = 'LINEAR16',
): GoogleSynthesisRequest => {
  const speakerAliasA = 'A';
  const speakerAliasB = 'B';
  const requiresSpeakerB = Boolean(draft.multiSpeaker) || draft.segments.some((segment) => segment.speaker === 'B');

  return {
    script: {
      model: draft.model,
      languageCode: draft.languageCode,
      multiSpeaker: draft.multiSpeaker,
      speakers: requiresSpeakerB
        ? {
            speakerA: { voiceId: draft.speakers.speakerA.voiceId, speakerAlias: speakerAliasA },
            speakerB: { voiceId: draft.speakers.speakerB.voiceId, speakerAlias: speakerAliasB },
          }
        : {
            speakerA: { voiceId: draft.speakers.speakerA.voiceId, speakerAlias: speakerAliasA },
          },
      segments: draft.segments.map((segment) => ({
        speaker: segment.speaker,
        text: segment.text,
      })),
      prompt: draft.prompt,
    },
    audioConfig: { audioEncoding: requestedAudioEncoding, sampleRateHertz: 24000 },
  };
};

export const getGoogleTtsInputLimitError = (requestPayload: GoogleSynthesisRequest) => {
  const prompt = requestPayload.script.prompt ?? '';
  const promptBytes = getUtf8ByteLength(prompt);
  if (promptBytes > GOOGLE_TTS_INPUT_BYTE_LIMIT) {
    return GOOGLE_TTS_PROMPT_LENGTH_ERROR_MESSAGE;
  }

  const tooLongSegment = requestPayload.script.segments.find((segment) => getUtf8ByteLength(segment.text) > GOOGLE_TTS_INPUT_BYTE_LIMIT);
  if (!tooLongSegment) return null;

  return GOOGLE_TTS_TEXT_LENGTH_ERROR_MESSAGE;
};
